"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var moment = require("moment");
var locales = require("date-fns/locale");
var react_redux_1 = require("react-redux");
var react_datepicker_1 = require("react-datepicker");
var react_router_dom_1 = require("react-router-dom");
var meterEntriesActions = require("@caddigital/sok-reducers/lib/actions/trmvrmeterentries/current");
var meterntriesListActions = require("@caddigital/sok-reducers/lib/actions/trmvrmeterentries/list");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
require("./newEntryModalStyles.scss");
var translate_1 = require("utils/translate");
var types_1 = require("types");
var constants_1 = require("utils/constants");
var mapStateToProps = function (state) {
    return {
        createStatus: state.trmvrmeterentries.current.status,
        trmvrmeterentries: state.trmvrmeterentries.list,
        createdEntryUuid: state.trmvrmeterentries.current.createdEntryUuid,
        currentTRMVRMeter: state.sokosite.current.trmvrMeter
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    createEntry: function (meterUuid, meterDate, meterType) {
        return dispatch(meterEntriesActions.createEntryRequest(meterUuid, meterDate, meterType));
    },
    fetchMeterEntries: function (meterUuid) {
        return dispatch(meterntriesListActions.fetchRequest(meterUuid));
    },
    clearState: function () { return dispatch(meterEntriesActions.clear()); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = (0, types_1.extractReturnType)(exports.mapStateToProps);
var dispatchPropsExtractable = (0, types_1.extractReturnType)(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), react_router_dom_1.withRouter, (0, recompose_1.lifecycle)({
    shouldComponentUpdate: function (nextProps) {
        if (this.props.createdEntryUuid !== nextProps.createdEntryUuid) {
            this.props.clearState();
        }
        return true;
    }
}), recompose_1.pure);
function handleSaveText(props) {
    if (props.createStatus === 'CREATING') {
        return React.createElement(sok_ui_1.LoadingSpinner, null);
    }
    return (0, translation_1.getLocalization)('diaryEntriesView/createNew/create');
}
function checkEntryExist(props, date) {
    var index = props.trmvrmeterentries.list.findIndex(function (item) { return moment(item.date).format('L') === moment(date).format('L'); });
    return index > -1;
}
function findEntry(props, date) {
    var index = props.trmvrmeterentries.list.findIndex(function (item) { return moment(item.date).format('L') === moment(date).format('L'); });
    if (props.createStatus === 'FAILEDTOCREATE') {
        props.clearState();
    }
    return props.trmvrmeterentries.list[index];
}
exports.default = enhance(function (props) {
    var _a;
    var _b = React.useState(true), showPrev = _b[0], setPrev = _b[1];
    var _c = React.useState(checkEntryExist(props, props.startDate)), entryExist = _c[0], setEntryExist = _c[1];
    var _d = React.useState(entryExist ? findEntry(props, props.startDate) : undefined), currentEntry = _d[0], setCurrentEntry = _d[1];
    var currentLanguage = (0, react_redux_1.useSelector)(function (state) { return state.translations; }).currentLanguage;
    var selectedLanguage = (0, translate_1.getLanguage)();
    React.useEffect(function () {
        setCurrentEntry(findEntry(props, props.startDate));
    }, [props.startDate, props.trmvrmeterentries]);
    React.useEffect(function () {
        setEntryExist(checkEntryExist(props, props.startDate));
        if (entryExist)
            setCurrentEntry(findEntry(props, props.startDate));
    }, [props.show]);
    React.useEffect(function () {
        if (props.createdEntryUuid) {
            props.history.push("/".concat(selectedLanguage, "/projects/").concat(props.currentProject.id, "/sokosite/trmvrmeter/").concat(props.currentTRMVRMeter.trmvrmeter_uuid, "/entries/").concat(props.createdEntryUuid));
        }
    }, [props.createdEntryUuid]);
    return (React.createElement(sok_ui_1.Modal, { isOpen: props.show, className: 'trmvrmeter-entries-modal-new-entry-calendar' },
        React.createElement(sok_ui_1.Header, { onClose: function () {
                setPrev(true);
                props.closeModal();
            } }, (0, translation_1.getLocalization)('diaryEntriesView/entries/chooseDateForNewEntry')),
        React.createElement("form", null,
            React.createElement(sok_ui_1.Container, null,
                React.createElement("div", { className: 'content' },
                    React.createElement(react_datepicker_1.default, { locale: (_a = locales[currentLanguage]) !== null && _a !== void 0 ? _a : constants_1.DEFAULT_LANGUAGE, inline: true, monthsShown: 2, selected: props.startDate, maxDate: moment().toDate(), showPreviousMonths: showPrev, onSelect: function () {
                            setPrev(false);
                        }, onMonthChange: function () {
                            setPrev(false);
                        }, onChange: function (date, e) {
                            if (e) {
                                e.stopPropagation();
                                e.preventDefault();
                            }
                            props.setStartDate(date);
                            setEntryExist(checkEntryExist(props, date));
                        } }),
                    props.createStatus === 'FAILEDTOCREATE' && (React.createElement("span", { className: 'request-failed' }, (0, translation_1.getLocalization)('diaryEntriesView/createNew/failed'))))),
            React.createElement(sok_ui_1.Footer, null,
                React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('diaryEntriesView/createNew/close'), color: 'dark-gray', onClick: function () {
                        setPrev(true);
                        props.closeModal();
                    } }),
                entryExist && currentEntry ? (React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('diaryEntriesView/createNew/open'), color: 'base-green', onClick: function () {
                        return props.history.push("/".concat(selectedLanguage, "/projects/").concat(props.currentProject.id, "/sokosite/trmvrmeter/").concat(props.currentTRMVRMeter.trmvrmeter_uuid, "/entries/").concat(currentEntry.uuid));
                    } })) : (React.createElement(sok_ui_1.Button, { disabled: props.createStatus === 'CREATING', text: handleSaveText(props), color: 'base-green', type: 'submit', onClick: function (e) {
                        e.preventDefault();
                        if (props.currentTRMVRMeter &&
                            props.currentTRMVRMeter.meterType) {
                            props.createEntry(props.currentTRMVRMeter.trmvrmeter_uuid, moment(props.startDate).format(), props.currentTRMVRMeter.meterType);
                        }
                        else {
                            alert('TRMVR meter not found');
                        }
                    } }))))));
});
